import { c as _c } from "react/compiler-runtime";
import { Typography } from '@mui/material';
export function Count(t0) {
  const $ = _c(5);
  const {
    count
  } = t0;
  if (count === undefined) {
    return null;
  }
  const t1 = count === 0 ? "neutral.lighter" : "neutral.main";
  let t2;
  if ($[0] !== t1) {
    t2 = {
      fontSize: 12,
      lineHeight: "12px",
      color: t1
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== count || $[3] !== t2) {
    t3 = <Typography component="span" sx={t2}>{count}</Typography>;
    $[2] = count;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}